import React, { useEffect } from 'react';

export function Notification({ message, type, onDismiss, duration = 4000 }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss();
    }, duration);
    
    return () => clearTimeout(timer);
  }, [duration, onDismiss]);
  
  const bgColor = type === 'error' ? 'bg-red-500' : 
                  type === 'warning' ? 'bg-yellow-500' : 
                  type === 'success' ? 'bg-green-500' : 'bg-blue-500';
  
  return (
    <div className={`fixed top-5 right-5 ${bgColor} text-white py-2 px-4 rounded-lg shadow-lg flex items-center z-50 animate-slide-in`}>
      <p className="text-sm">{message}</p>
      <button onClick={onDismiss} className="ml-4 font-bold hover:opacity-80 text-lg">
        ×
      </button>
    </div>
  );
}